import { createFeatureSelector, createSelector } from '@ngrx/store';

import { businessProfilesFeatureKey, BusinessProfilesState } from './business-profiles.reducer';

export const selectBusinessProfilesState = createFeatureSelector<BusinessProfilesState>(businessProfilesFeatureKey);

export const selectProfiles = createSelector(selectBusinessProfilesState, (state) => state.profiles);

export const selectLoading = createSelector(selectBusinessProfilesState, (state) => state.loading);

export const selectSyncing = createSelector(selectBusinessProfilesState, (state) => state.syncing);

export const selectError = createSelector(selectBusinessProfilesState, (state) => state.error);

export const selectAllProfiles = createSelector(selectBusinessProfilesState, (state) => state.allProfiles);

export const selectAllProfilesLoading = createSelector(
  selectBusinessProfilesState,
  (state) => state.allProfilesLoading,
);

export const selectAllProfilesSyncing = createSelector(
  selectBusinessProfilesState,
  (state) => state.allProfilesSyncing,
);

export const selectAccounts = createSelector(selectBusinessProfilesState, (state) => state.accounts);

export const selectAccountsLoading = createSelector(selectBusinessProfilesState, (state) => state.accountsLoading);

export const selectAdsLabelSaving = createSelector(selectBusinessProfilesState, (state) => state.adsLabelSaving);

export const selectAdsLabelListingsFailed = createSelector(
  selectBusinessProfilesState,
  (state) => state.adsLabelListingsFailed,
);

export const selectTransferring = createSelector(selectBusinessProfilesState, (state) => state.transferring);

export const selectTransferResult = createSelector(selectBusinessProfilesState, (state) => state.transferResult);

export const selectTransferError = createSelector(selectBusinessProfilesState, (state) => state.transferError);
